// DO NOT EDIT -- generated from fs/services/ingestion-settings/recording.proto

import * as cook from '../../cook';
import * as flags from '../../shared/flags';
import * as fullstory_settings_recording_v1 from '../../api/fullstoryapis/settings/recording/v1alpha';
import * as orgs from '../orgs';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as schema from '../../shared/schema';
import * as segment from '../../api/segment';

export namespace RecordingConfig {

  export const GetRecordingConfigEndpoint = "/grpc/ingestion_settings.RecordingConfig/GetRecordingConfig";
  /** Get all of the stored recording config for an org. */
  export function GetRecordingConfig(sender: (req: GetRecordingConfigRequest, endpoint: string) => Promise<GetRecordingConfigResponse>, req: GetRecordingConfigRequest): { promise: () => Promise<GetRecordingConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingConfigEndpoint),
      endpoint: GetRecordingConfigEndpoint
    };
  }

  export const UpdateOrgStateRecordEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateOrgStateRecord";
  export function UpdateOrgStateRecord(sender: (req: OrgStateTask, endpoint: string) => Promise<{}>, req: OrgStateTask): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateOrgStateRecordEndpoint),
      endpoint: UpdateOrgStateRecordEndpoint
    };
  }

  export const UpdateRecordingFeaturesEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateRecordingFeatures";
  export function UpdateRecordingFeatures(sender: (req: UpdateRecordingFeaturesRequest, endpoint: string) => Promise<RecordingFeatures>, req: UpdateRecordingFeaturesRequest): { promise: () => Promise<RecordingFeatures>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateRecordingFeaturesEndpoint),
      endpoint: UpdateRecordingFeaturesEndpoint
    };
  }

  export const UpdateBehaviorSignalSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateBehaviorSignalSettings";
  export function UpdateBehaviorSignalSettings(sender: (req: UpdateBehaviorSignalSettingsRequest, endpoint: string) => Promise<UpdateBehaviorSignalSettingsResponse>, req: UpdateBehaviorSignalSettingsRequest): { promise: () => Promise<UpdateBehaviorSignalSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateBehaviorSignalSettingsEndpoint),
      endpoint: UpdateBehaviorSignalSettingsEndpoint
    };
  }

  export const UpdateDomainSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateDomainSettings";
  export function UpdateDomainSettings(sender: (req: UpdateDomainSettingsRequest, endpoint: string) => Promise<DomainSettings>, req: UpdateDomainSettingsRequest): { promise: () => Promise<DomainSettings>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDomainSettingsEndpoint),
      endpoint: UpdateDomainSettingsEndpoint
    };
  }

  export const GetDomainSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfig/GetDomainSettings";
  export function GetDomainSettings(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetDomainSettingsResponse>, req: GenericGetRequest): { promise: () => Promise<GetDomainSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDomainSettingsEndpoint),
      endpoint: GetDomainSettingsEndpoint
    };
  }

  export const UpdateElementWatchSetEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateElementWatchSet";
  export function UpdateElementWatchSet(sender: (req: UpdateElementWatchSetRequest, endpoint: string) => Promise<ElementWatchSet>, req: UpdateElementWatchSetRequest): { promise: () => Promise<ElementWatchSet>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateElementWatchSetEndpoint),
      endpoint: UpdateElementWatchSetEndpoint
    };
  }

  export const UpdateGeoSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateGeoSettings";
  export function UpdateGeoSettings(sender: (req: UpdateGeoSettingsRequest, endpoint: string) => Promise<GeoSettings>, req: UpdateGeoSettingsRequest): { promise: () => Promise<GeoSettings>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateGeoSettingsEndpoint),
      endpoint: UpdateGeoSettingsEndpoint
    };
  }

  export const UpdateRecordingBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateRecordingBlockRules";
  export function UpdateRecordingBlockRules(sender: (req: UpdateRecordingBlockRulesRequest, endpoint: string) => Promise<RecordingBlockRules>, req: UpdateRecordingBlockRulesRequest): { promise: () => Promise<RecordingBlockRules>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateRecordingBlockRulesEndpoint),
      endpoint: UpdateRecordingBlockRulesEndpoint
    };
  }

  export const UpdateTargetingRuleSetEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateTargetingRuleSet";
  export function UpdateTargetingRuleSet(sender: (req: UpdateTargetingRuleSetRequest, endpoint: string) => Promise<TargetingRuleSet>, req: UpdateTargetingRuleSetRequest): { promise: () => Promise<TargetingRuleSet>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateTargetingRuleSetEndpoint),
      endpoint: UpdateTargetingRuleSetEndpoint
    };
  }

  export const UpdatePrivacySettingsEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdatePrivacySettings";
  export function UpdatePrivacySettings(sender: (req: UpdatePrivacySettingsRequest, endpoint: string) => Promise<PrivacySettings>, req: UpdatePrivacySettingsRequest): { promise: () => Promise<PrivacySettings>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePrivacySettingsEndpoint),
      endpoint: UpdatePrivacySettingsEndpoint
    };
  }

  export const GetKeepRulesEndpoint = "/grpc/ingestion_settings.RecordingConfig/GetKeepRules";
  /**
   * TODO(ianrose): delete once unused (humans can just use the rpc on the RecordingConfigPublic service)
   * Get one or more URL and/or Element Keep rules from an org.
   */
  export function GetKeepRules(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetKeepRulesResponse>, req: GenericGetRequest): { promise: () => Promise<GetKeepRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetKeepRulesEndpoint),
      endpoint: GetKeepRulesEndpoint
    };
  }

  export const UpdateKeepRulesEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateKeepRules";
  /** Add or remove URL and/or Element Keep rules of an org. */
  export function UpdateKeepRules(sender: (req: UpdateKeepRulesRequest, endpoint: string) => Promise<KeepRuleSet>, req: UpdateKeepRulesRequest): { promise: () => Promise<KeepRuleSet>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateKeepRulesEndpoint),
      endpoint: UpdateKeepRulesEndpoint
    };
  }

  export const UpdateDwellRuleEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateDwellRule";
  export function UpdateDwellRule(sender: (req: UpdateDwellRulesRequest, endpoint: string) => Promise<KeepRuleSet>, req: UpdateDwellRulesRequest): { promise: () => Promise<KeepRuleSet>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDwellRuleEndpoint),
      endpoint: UpdateDwellRuleEndpoint
    };
  }

  export const GetOrgStatesEndpoint = "/grpc/ingestion_settings.RecordingConfig/GetOrgStates";
  /** Get one or more OrgState entities from an org. */
  export function GetOrgStates(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetOrgStatesResponse>, req: GenericGetRequest): { promise: () => Promise<GetOrgStatesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrgStatesEndpoint),
      endpoint: GetOrgStatesEndpoint
    };
  }

  export const ScheduleOrgStateReconciliationEndpoint = "/grpc/ingestion_settings.RecordingConfig/ScheduleOrgStateReconciliation";
  export function ScheduleOrgStateReconciliation(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ScheduleOrgStateReconciliationEndpoint),
      endpoint: ScheduleOrgStateReconciliationEndpoint
    };
  }

  export const SetSampleRateEndpoint = "/grpc/ingestion_settings.RecordingConfig/SetSampleRate";
  /**
   * Set the sampling rate for a given org. Sampled sessions will be available for playback.
   * Unsampled sessions will not be playable, but associated analytics data will be sent to data destinations.
   */
  export function SetSampleRate(sender: (req: SetSampleRateRequest, endpoint: string) => Promise<{}>, req: SetSampleRateRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetSampleRateEndpoint),
      endpoint: SetSampleRateEndpoint
    };
  }

  export const RefreshPublicCaptureConfigEndpoint = "/grpc/ingestion_settings.RecordingConfig/RefreshPublicCaptureConfig";
  /** RefreshPublicCaptureConfig will refresh the cached, static public capture config for an org that is stored in GCS. */
  export function RefreshPublicCaptureConfig(sender: (req: RefreshPublicCaptureConfigRequest, endpoint: string) => Promise<{}>, req: RefreshPublicCaptureConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RefreshPublicCaptureConfigEndpoint),
      endpoint: RefreshPublicCaptureConfigEndpoint
    };
  }

  export const RestoreLegacyElementBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfig/RestoreLegacyElementBlockRules";
  /**
   * Loops through an org's PrivacySettings to find the most recent version with elementBlockRules and restores it.
   * This should only be used for the migration from elementBlockRules to namedElementBlockRules.
   * This function will be cleaned up and removed once we are comfortable with the migraiton. - SNT-745
   */
  export function RestoreLegacyElementBlockRules(sender: (req: RestoreLegacyElementBlockRulesRequest, endpoint: string) => Promise<{}>, req: RestoreLegacyElementBlockRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, RestoreLegacyElementBlockRulesEndpoint),
      endpoint: RestoreLegacyElementBlockRulesEndpoint
    };
  }

  export const BatchUpdateNamedElementBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfig/BatchUpdateNamedElementBlockRules";
  /**
   * A helper function for migrating all the legacy element block rules to named element block rules.
   * This function will be removed after the migration has settled - SNT-745
   */
  export function BatchUpdateNamedElementBlockRules(sender: (req: BatchUpdateNamedElementBlockRulesRequest, endpoint: string) => Promise<{}>, req: BatchUpdateNamedElementBlockRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BatchUpdateNamedElementBlockRulesEndpoint),
      endpoint: BatchUpdateNamedElementBlockRulesEndpoint
    };
  }

  export const UpdateFormPrivacyNamedElementBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateFormPrivacyNamedElementBlockRules";
  /**
   * Update form privacy configuration for an org once named element block rules have become the standard.
   * This design is so that we can prioritize form privacy management functionality without having to port over all
   * of the group management functionality from the existing element block rules.
   * This endpoint is specifically for machine callers such as webber setting up a new org.
   */
  export function UpdateFormPrivacyNamedElementBlockRules(sender: (req: UpdateFormPrivacyNamedElementBlockRulesRequest, endpoint: string) => Promise<{}>, req: UpdateFormPrivacyNamedElementBlockRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateFormPrivacyNamedElementBlockRulesEndpoint),
      endpoint: UpdateFormPrivacyNamedElementBlockRulesEndpoint
    };
  }

  export const UpdateNamedElementBlockRuleEndpoint = "/grpc/ingestion_settings.RecordingConfig/UpdateNamedElementBlockRule";
  /**
   * Create / update a named element block rules for an org
   * This endpoint is specifically for machine callers such as test cases using RecordingConfig clients.
   */
  export function UpdateNamedElementBlockRule(sender: (req: UpdateNamedElementBlockRuleRequest, endpoint: string) => Promise<UpdateNamedElementBlockRuleResponse>, req: UpdateNamedElementBlockRuleRequest): { promise: () => Promise<UpdateNamedElementBlockRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNamedElementBlockRuleEndpoint),
      endpoint: UpdateNamedElementBlockRuleEndpoint
    };
  }
}

/** To-be accessed from FSTA */
export namespace RecordingConfigPublic {

  export const GetRecordingFeaturesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetRecordingFeatures";
  export function GetRecordingFeatures(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetRecordingFeaturesResponse>, req: GenericGetRequest): { promise: () => Promise<GetRecordingFeaturesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingFeaturesEndpoint),
      endpoint: GetRecordingFeaturesEndpoint
    };
  }

  export const UpdateRecordingFeaturesPublicEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateRecordingFeaturesPublic";
  export function UpdateRecordingFeaturesPublic(sender: (req: UpdateRecordingFeaturesPublicRequest, endpoint: string) => Promise<RecordingFeatures>, req: UpdateRecordingFeaturesPublicRequest): { promise: () => Promise<RecordingFeatures>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateRecordingFeaturesPublicEndpoint),
      endpoint: UpdateRecordingFeaturesPublicEndpoint
    };
  }

  export const GetBehaviorSignalSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetBehaviorSignalSettings";
  export function GetBehaviorSignalSettings(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetBehaviorSignalSettingsResponse>, req: GenericGetRequest): { promise: () => Promise<GetBehaviorSignalSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetBehaviorSignalSettingsEndpoint),
      endpoint: GetBehaviorSignalSettingsEndpoint
    };
  }

  export const UpdateBehaviorSignalSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateBehaviorSignalSettings";
  export function UpdateBehaviorSignalSettings(sender: (req: UpdateBehaviorSignalSettingsRequest, endpoint: string) => Promise<UpdateBehaviorSignalSettingsResponse>, req: UpdateBehaviorSignalSettingsRequest): { promise: () => Promise<UpdateBehaviorSignalSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateBehaviorSignalSettingsEndpoint),
      endpoint: UpdateBehaviorSignalSettingsEndpoint
    };
  }

  export const GetDomainSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetDomainSettings";
  export function GetDomainSettings(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetDomainSettingsResponse>, req: GenericGetRequest): { promise: () => Promise<GetDomainSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDomainSettingsEndpoint),
      endpoint: GetDomainSettingsEndpoint
    };
  }

  export const GetElementWatchSetEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetElementWatchSet";
  export function GetElementWatchSet(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetElementWatchSetResponse>, req: GenericGetRequest): { promise: () => Promise<GetElementWatchSetResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementWatchSetEndpoint),
      endpoint: GetElementWatchSetEndpoint
    };
  }

  export const GetElementDeferredRuleSetEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetElementDeferredRuleSet";
  export function GetElementDeferredRuleSet(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetElementDeferredRuleSetResponse>, req: GenericGetRequest): { promise: () => Promise<GetElementDeferredRuleSetResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementDeferredRuleSetEndpoint),
      endpoint: GetElementDeferredRuleSetEndpoint
    };
  }

  export const UpdateElementDeferredRuleSetEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateElementDeferredRuleSet";
  export function UpdateElementDeferredRuleSet(sender: (req: UpdateElementDeferredRuleSetRequest, endpoint: string) => Promise<ElementDeferredRuleSet>, req: UpdateElementDeferredRuleSetRequest): { promise: () => Promise<ElementDeferredRuleSet>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateElementDeferredRuleSetEndpoint),
      endpoint: UpdateElementDeferredRuleSetEndpoint
    };
  }

  export const GetGeoSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetGeoSettings";
  export function GetGeoSettings(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetGeoSettingsResponse>, req: GenericGetRequest): { promise: () => Promise<GetGeoSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetGeoSettingsEndpoint),
      endpoint: GetGeoSettingsEndpoint
    };
  }

  export const GetRecordingBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetRecordingBlockRules";
  export function GetRecordingBlockRules(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetRecordingBlockRulesResponse>, req: GenericGetRequest): { promise: () => Promise<GetRecordingBlockRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingBlockRulesEndpoint),
      endpoint: GetRecordingBlockRulesEndpoint
    };
  }

  export const GetTargetingRuleSetEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetTargetingRuleSet";
  export function GetTargetingRuleSet(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetTargetingRuleSetResponse>, req: GenericGetRequest): { promise: () => Promise<GetTargetingRuleSetResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetTargetingRuleSetEndpoint),
      endpoint: GetTargetingRuleSetEndpoint
    };
  }

  export const GetPrivacySettingsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetPrivacySettings";
  export function GetPrivacySettings(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetPrivacySettingsResponse>, req: GenericGetRequest): { promise: () => Promise<GetPrivacySettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPrivacySettingsEndpoint),
      endpoint: GetPrivacySettingsEndpoint
    };
  }

  export const UpdateElementBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateElementBlockRules";
  /** @deprecated */
  export function UpdateElementBlockRules(sender: (req: UpdateElementBlockRulesRequest, endpoint: string) => Promise<UpdateElementBlockRulesResponse>, req: UpdateElementBlockRulesRequest): { promise: () => Promise<UpdateElementBlockRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateElementBlockRulesEndpoint),
      endpoint: UpdateElementBlockRulesEndpoint
    };
  }

  export const GetKeepRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetKeepRules";
  /** Get one or more URL and/or Element Keep rules from an org. */
  export function GetKeepRules(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetKeepRulesResponse>, req: GenericGetRequest): { promise: () => Promise<GetKeepRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetKeepRulesEndpoint),
      endpoint: GetKeepRulesEndpoint
    };
  }

  export const UpdateDatalossSettingsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateDatalossSettings";
  export function UpdateDatalossSettings(sender: (req: UpdateDatalossSettingsRequest, endpoint: string) => Promise<UpdateDatalossSettingsResponse>, req: UpdateDatalossSettingsRequest): { promise: () => Promise<UpdateDatalossSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDatalossSettingsEndpoint),
      endpoint: UpdateDatalossSettingsEndpoint
    };
  }

  export const UpdateDefaultPrivacyModeEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateDefaultPrivacyMode";
  export function UpdateDefaultPrivacyMode(sender: (req: UpdateDefaultPrivacyModeRpcRequest, endpoint: string) => Promise<{}>, req: UpdateDefaultPrivacyModeRpcRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDefaultPrivacyModeEndpoint),
      endpoint: UpdateDefaultPrivacyModeEndpoint
    };
  }

  export const GetUrlPrivacyRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetUrlPrivacyRules";
  /** Retrieve all the URL privacy rules for an org */
  export function GetUrlPrivacyRules(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetUrlPrivacyRulesResponse>, req: GenericGetRequest): { promise: () => Promise<GetUrlPrivacyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUrlPrivacyRulesEndpoint),
      endpoint: GetUrlPrivacyRulesEndpoint
    };
  }

  export const UpdateUrlPrivacyRuleEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateUrlPrivacyRule";
  /** Add a new URL privacy rule record or update an existing URL privacy rule record */
  export function UpdateUrlPrivacyRule(sender: (req: UpdateUrlPrivacyRuleRequest, endpoint: string) => Promise<{}>, req: UpdateUrlPrivacyRuleRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateUrlPrivacyRuleEndpoint),
      endpoint: UpdateUrlPrivacyRuleEndpoint
    };
  }

  export const DeleteUrlPrivacyRuleEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/DeleteUrlPrivacyRule";
  /** Remove a URL privacy rule record */
  export function DeleteUrlPrivacyRule(sender: (req: DeleteUrlPrivacyRuleRequest, endpoint: string) => Promise<{}>, req: DeleteUrlPrivacyRuleRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteUrlPrivacyRuleEndpoint),
      endpoint: DeleteUrlPrivacyRuleEndpoint
    };
  }

  export const GetDetectionsConfigurationRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetDetectionsConfigurationRules";
  /** Retrieve a customer's detections configuration rules */
  export function GetDetectionsConfigurationRules(sender: (req: GenericGetRequest, endpoint: string) => Promise<GetDetectionsConfigurationRulesResponse>, req: GenericGetRequest): { promise: () => Promise<GetDetectionsConfigurationRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDetectionsConfigurationRulesEndpoint),
      endpoint: GetDetectionsConfigurationRulesEndpoint
    };
  }

  export const UpdateDetectionsConfigurationRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateDetectionsConfigurationRules";
  /** Updates a customer's Detections config */
  export function UpdateDetectionsConfigurationRules(sender: (req: UpdateDetectionsConfigurationRulesRequest, endpoint: string) => Promise<{}>, req: UpdateDetectionsConfigurationRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDetectionsConfigurationRulesEndpoint),
      endpoint: UpdateDetectionsConfigurationRulesEndpoint
    };
  }

  export const ValidateBlockedIpRuleEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/ValidateBlockedIpRule";
  /**
   * ValidateBlockedIpRule will validate the format of an input blocked ip rule and return a user-visible error message
   * if there are any issues.
   */
  export function ValidateBlockedIpRule(sender: (req: ValidateBlockedIpRuleRequest, endpoint: string) => Promise<ValidateBlockedIpRuleResponse>, req: ValidateBlockedIpRuleRequest): { promise: () => Promise<ValidateBlockedIpRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ValidateBlockedIpRuleEndpoint),
      endpoint: ValidateBlockedIpRuleEndpoint
    };
  }

  export const GetNamedElementBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetNamedElementBlockRules";
  /** Retrieve the named element block rules for an org */
  export function GetNamedElementBlockRules(sender: (req: GetNamedElementBlockRulesRequest, endpoint: string) => Promise<GetNamedElementBlockRulesResponse>, req: GetNamedElementBlockRulesRequest): { promise: () => Promise<GetNamedElementBlockRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementBlockRulesEndpoint),
      endpoint: GetNamedElementBlockRulesEndpoint
    };
  }

  export const UpdateNamedElementBlockRuleEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateNamedElementBlockRule";
  /** Create / update a named element block rules for an org */
  export function UpdateNamedElementBlockRule(sender: (req: UpdateNamedElementBlockRuleRequest, endpoint: string) => Promise<UpdateNamedElementBlockRuleResponse>, req: UpdateNamedElementBlockRuleRequest): { promise: () => Promise<UpdateNamedElementBlockRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNamedElementBlockRuleEndpoint),
      endpoint: UpdateNamedElementBlockRuleEndpoint
    };
  }

  export const DeleteNamedElementBlockRuleEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/DeleteNamedElementBlockRule";
  /** Delete a named element block rule for an org */
  export function DeleteNamedElementBlockRule(sender: (req: DeleteNamedElementBlockRuleRequest, endpoint: string) => Promise<DeleteNamedElementBlockRuleResponse>, req: DeleteNamedElementBlockRuleRequest): { promise: () => Promise<DeleteNamedElementBlockRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteNamedElementBlockRuleEndpoint),
      endpoint: DeleteNamedElementBlockRuleEndpoint
    };
  }

  export const UpdateFormPrivacyNamedElementBlockRulesEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/UpdateFormPrivacyNamedElementBlockRules";
  /**
   * Update form privacy configuration for an org once named element block rules have become the standard.
   * This design is so that we can prioritize form privacy management functionality without having to port over all
   * of the group management functionality from the existing element block rules.
   */
  export function UpdateFormPrivacyNamedElementBlockRules(sender: (req: UpdateFormPrivacyNamedElementBlockRulesRequest, endpoint: string) => Promise<{}>, req: UpdateFormPrivacyNamedElementBlockRulesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateFormPrivacyNamedElementBlockRulesEndpoint),
      endpoint: UpdateFormPrivacyNamedElementBlockRulesEndpoint
    };
  }

  export const GetPrivacyFeatureVersionBoundsEndpoint = "/grpc/ingestion_settings.RecordingConfigPublic/GetPrivacyFeatureVersionBounds";
  /**
   * Returns the base values for min/max versions that delineate capture clients
   * that can and cannot support NamedElementBlockRules.
   */
  export function GetPrivacyFeatureVersionBounds(sender: (req: GetPrivacyFeatureVersionBoundsRequest, endpoint: string) => Promise<GetPrivacyFeatureVersionBoundsResponse>, req: GetPrivacyFeatureVersionBoundsRequest): { promise: () => Promise<GetPrivacyFeatureVersionBoundsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPrivacyFeatureVersionBoundsEndpoint),
      endpoint: GetPrivacyFeatureVersionBoundsEndpoint
    };
  }
}

export interface GetPrivacyFeatureVersionBoundsResponse {
  mobileDescendantSelectorSupport: MobileDescendantSelectorSupport | null;
}

export interface MobileDescendantSelectorSupport {
  minSdkVersion: CaptureClientVersion | null;
}

export interface GetPrivacyFeatureVersionBoundsRequest {
}

export interface GetRecordingConfigRequest {
  orgId: string;
  /** If true, fetch mobile recording configs.  If false, fetch web recording configs. */
  mobile: boolean;
}

export interface GetRecordingConfigResponse {
  /** General org-level configuration */
  features: RecordingFeatures | null;
  domains: DomainSettings | null;
  elementWatches: ElementWatchSet | null;
  geo: GeoSettings | null;
  blockRules: RecordingBlockRules | null;
  targets: TargetingRuleSet | null;
  privacySettings: PrivacySettings | null;
  keepRules: KeepRuleSet | null;
  elementDeferreds: ElementDeferredRuleSet | null;
  orgSettings: OrgSettings | null;
  orgState: OrgStateRecord | null;
  behaviorSignalSettings: BehaviorSignalSettings | null;
}

export interface GenericGetRequest {
  /** required */
  orgId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
  /** not applicable for all kinds */
  mobile: boolean;
}

export interface SetSampleRateRequest {
  orgId: string;
  /** Can specify valid values between 0 and 1.0 */
  sampleRate: number;
}

export interface RecordingFeatures {
  /**
   * whether recording is enabled at all
   * Replaced and *always overridden* by recording_active.
   * 
   * @deprecated
   */
  enabled: boolean;
  consoleWatcher: boolean;
  ajaxWatcher: boolean;
  resourceUploading: boolean;
  /** Indicates if all recording has been shut off by FS personnel, usually via admin pages */
  recordingShutoff: boolean;
  metadata: protoauditstore.AuditMetadata | null;
  /**
   * fraction of recording traffic (by User) to drop on the floor (seldom used)
   * 
   * @deprecated
   */
  trafficFiltering: number;
  /** Indicates that client side events should or should not be emitted */
  clientSideRageClick: boolean;
  recordingActive: fullstory_settings_recording_v1.RecordingActiveFor;
  mobileImageUnmaskMode: AutomaticImageUnmaskMode;
  /** Indicates if FS.Focus preview mode is enabled or disabled */
  keepRecordingType: KeepRecordingType;
  /** Optional - only populated if the org uses a custom domain endpoint (formerly known as FullStory Hosted Relay). */
  customEndpoint: string;
  /**
   * The percentage of sessions to "drop" from FSTA for orgs utilizing post-cook session sampling.
   * This feature has been moved to the OrgStateRecord.
   * 
   * @deprecated
   */
  dropRate: number;
  canvasWatcherMode: fullstory_settings_recording_v1.CanvasWatcherMode;
}

export interface GetRecordingFeaturesRequest {
  orgId: string;
}

export interface GetRecordingFeaturesResponse {
  versions: RecordingFeatures[];
}

/**
 * UpdateRecordingFeaturesPublicRequest is a "stripped down" version of UpdateRecordingFeaturesRequest,
 * which exposes only those options that are settable by fullstory clients.
 */
export interface UpdateRecordingFeaturesPublicRequest {
  orgId: string;
  clientSideRageClick: boolean | null;
}

export interface UpdateRecordingFeaturesRequest {
  orgId: string;
  mobile: boolean;
  /** @deprecated */
  enabled: boolean | null;
  consoleWatcher: boolean | null;
  ajaxWatcher: boolean | null;
  resourceUploading: boolean | null;
  recordingShutoff: boolean | null;
  trafficFiltering: number | null;
  clientSideRageClick: boolean | null;
  recordingActive: UpdateRecordingActiveFor | null;
  mobileImageUnmaskMode: UpdateAutomaticImageUnmaskModeRequest | null;
  keepRecordingType: UpdateKeepRecordingType | null;
  customEndpoint: string | null;
  canvasWatcherMode: UpdateCanvasWatcherMode | null;
}

export interface UpdateRecordingActiveFor {
  value: fullstory_settings_recording_v1.RecordingActiveFor;
}

export interface UpdateCanvasWatcherMode {
  value: fullstory_settings_recording_v1.CanvasWatcherMode;
}

export enum BehaviorSignalType {
  SIGNAL_INVALID = 0,
  SIGNAL_DEAD_CLICK = 1,
  SIGNAL_RAGE_CLICK = 2
}

export interface BehaviorSignalElementBlock {
  /**
   * Named element id indicates the stored named element for which this behavior signal element block exists.
   * Named elements is the preferred mechanism for configuring these blocks moving forward.
   * When present, selector and notes will not be present as those are stored in search-settings.
   */
  namedElementId: string;
  /** @deprecated */
  selector: string;
  /** @deprecated */
  notes: string;
  signals: BehaviorSignalType[];
}

export interface BehaviorSignalElementBlockUpdate {
  /** can be unspecified (modifies existing), but cannot be empty string */
  namedElementId: string | null;
  /**
   * can be unspecified (modifies existing selector), but cannot be empty string
   * 
   * @deprecated
   */
  selector: string | null;
  /** @deprecated */
  notes: string | null;
  addSignals: BehaviorSignalType[];
  removeSignals: BehaviorSignalType[];
}

export interface BehaviorSignalSettings {
  elementBlocks: BehaviorSignalElementBlock[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetBehaviorSignalSettingsResponse {
  versions: BehaviorSignalSettings[];
}

export interface UpdateBehaviorSignalSettingsRequest {
  orgId: string;
  elementBlockAdds: BehaviorSignalElementBlock[];
  /**
   * selectors to delete
   * 
   * @deprecated
   */
  elementBlockDeletes: string[];
  /** named element ids to delete */
  elementBlockDeletesByNamedElementId: string[];
  /**
   * key is existing selector
   * 
   * @deprecated
   */
  elementBlockUpdates: { [key: string]: BehaviorSignalElementBlockUpdate };
  /** key is existing named element id */
  elementBlockUpdatesByNamedElementId: { [key: string]: BehaviorSignalElementBlockUpdate };
}

export interface UpdateBehaviorSignalSettingsResponse {
  behaviorSignalSettings: BehaviorSignalSettings | null;
}

export interface KnownDomainUpdate {
  /** can be unspecified (modifies existing selector), but cannot be empty string */
  domain: string | null;
  disabled: boolean | null;
}

export interface DomainSettings {
  onlyRecordKnownDomains: boolean;
  domains: fullstory_settings_recording_v1.KnownDomain[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetDomainSettingsResponse {
  versions: DomainSettings[];
}

export interface UpdateDomainSettingsRequest {
  orgId: string;
  mobile: boolean;
  onlyRecordKnownDomains: boolean | null;
  addDomains: fullstory_settings_recording_v1.KnownDomain[];
  removeDomains: string[];
  updateDomains: { [key: string]: KnownDomainUpdate };
}

export interface ElementWatchRule {
  /**
   * Named element id indicates the stored named element for which this watch rule exists.
   * Named elements is the preferred mechanism for configuring watch rules.
   * When present, selector, label, and notes will not be present as those are stored in search-settings.
   */
  namedElementId: string;
  /** @deprecated */
  selector: string;
  /** @deprecated */
  label: string;
  /** @deprecated */
  notes: string;
  lastUpdated: protobuf.timestamp | null;
}

export interface ElementWatchRuleUpdate {
  /** can be unspecified (modifies existing selector), but cannot be empty string */
  selector: string | null;
  label: string | null;
  notes: string | null;
}

export interface ElementWatchSet {
  watches: ElementWatchRule[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetElementWatchSetResponse {
  versions: ElementWatchSet[];
}

export interface UpdateElementWatchSetRequest {
  orgId: string;
  addWatches: ElementWatchRule[];
  /**
   * Selector based for ad-hoc historical watches.
   * 
   * @deprecated
   */
  removeWatches: string[];
  /** Remove a watch based on named element id. */
  removeWatchesByNamedElementId: string[];
  /**
   * Updates for selector based for ad-hoc historical watches.
   * Named element based watches are updated through search-settings.
   * 
   * @deprecated
   */
  updateWatches: { [key: string]: ElementWatchRuleUpdate };
}

export interface ElementDeferredRule {
  selector: string;
  lastUpdated: protobuf.timestamp | null;
}

export interface ElementDeferredRuleSet {
  rules: ElementDeferredRule[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface UpdateElementDeferredRuleSetRequest {
  orgId: string;
  addElementDeferreds: ElementDeferredRule[];
  removeElementDeferreds: string[];
}

export interface GetElementDeferredRuleSetResponse {
  versions: ElementDeferredRuleSet[];
}

export interface GeoRecordModeUpdate {
  value: fullstory_settings_recording_v1.GeoRecordMode;
}

export interface GeoSettings {
  recordGeoMode: fullstory_settings_recording_v1.GeoRecordMode;
  recordGeoZones: string[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetGeoSettingsResponse {
  versions: GeoSettings[];
}

export interface UpdateGeoSettingsRequest {
  orgId: string;
  recordGeoMode: GeoRecordModeUpdate | null;
  addRecordGeoZones: string[];
  removeRecordGeoZones: string[];
}

export interface RecordingBlockRules {
  blockedIps: string[];
  blockedUas: string[];
  blockedAppIds: string[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetRecordingBlockRulesResponse {
  versions: RecordingBlockRules[];
}

export interface UpdateRecordingBlockRulesRequest {
  orgId: string;
  addBlockedIps: string[];
  removeBlockedIps: string[];
  addBlockedUas: string[];
  removeBlockedUas: string[];
  addBlockedAppIds: string[];
  removeBlockedAppIds: string[];
}

export interface TargetingRuleSet {
  sessionTargetingRules: fullstory_settings_recording_v1.TargetingRule[];
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetTargetingRuleSetResponse {
  versions: TargetingRuleSet[];
}

export interface UpdateTargetingRuleSetRequest {
  orgId: string;
  addSessionTargetingRules: fullstory_settings_recording_v1.TargetingRule[];
  removeSessionTargetingRules: string[];
  updateSessionTargetingRules: { [key: string]: fullstory_settings_recording_v1.TargetingRule };
}

export interface TargetingConditionSetUpdate {
  value: fullstory_settings_recording_v1.TargetingConditionSet | null;
}

export interface PrivacySettings {
  /**
   * This field contains the raw element blocks set by the customer as part of
   * their recording configuration. Don't use it directly for recording;
   * instead, call EvalElementBlocks() to get the final set of element blocks
   * that the recording script/plugins should see.
   */
  elementBlocks: ElementBlockRules[];
  namedElementBlockRules: NamedElementBlockRule[];
  ajaxWatches: fullstory_settings_recording_v1.AjaxWatchRule[];
  discardIpAddresses: boolean;
  metadata: protoauditstore.AuditMetadata | null;
  defaultPrivacyMode: DefaultPrivacyMode;
  datalossIgnores: DatalossIgnoreRule[];
  /** Url Privacy Rules will be stored/read in the same datastore `kind` as privacy settings versus staying in org settings */
  urlPrivacyRules: fullstory_settings_recording_v1.UrlPrivacyRule[];
  detectionsConfigRules: DetectionsConfigurationRules | null;
  /** Element Privacy rule groups for this org. */
  elementRuleGroups: { [key: string]: fullstory_settings_recording_v1.ElementPrivacyRuleGroup };
}

/** Defines the different automatic image unmasking modes */
export enum AutomaticImageUnmaskMode {
  /** invalid option, never match */
  UNMASK_MODE_UNSET = 0,
  /** automatic unmasking disabled */
  UNMASK_MODE_OFF = 1,
  /** automatic image unmasking for built-in assets */
  UNMASK_MODE_ASSETS = 2
}

/**
 * If and how the recording script should apply "private by default".
 * We're currently transitioning from the MASK_BODY strategy for
 * implementing PBD to MASK_DEFAULT (CH122471 and related). Eventually
 * we will stop supporting MASK_BODY.
 */
export enum DefaultPrivacyMode {
  /** Do not add any PBD masking, except when WhitelistElements is on (backwards compatibility) */
  PRIVACY_MODE_OFF = 0,
  /** Implement PBD by masking the CSS selector "body". */
  PRIVACY_MODE_MASK_BODY = 1,
  /** Implement PBD by masking html and unmasking link/style/base. */
  PRIVACY_MODE_MASK_DEFAULT = 2
}

/**
 * A set of rules defining a customer's Detections configuration. We are starting with
 * whether Detections is turned on or off for a customer, but future rules may include
 * which type of "extra" detectors to capture such as SSN, email, etc.
 */
export interface DetectionsConfigurationRules {
  detectionsEnabled: boolean;
}

export interface UpdateDetectionsConfigurationRulesRequest {
  orgId: string;
  detectionsConfigRules: DetectionsConfigurationRules | null;
}

export interface ElementBlockRules {
  selector: string;
  consent: boolean;
  notes: string;
  type: fullstory_settings_recording_v1.BlockType;
  scope: fullstory_settings_recording_v1.RuleScope;
  lastUpdated: protobuf.timestamp | null;
  label: string;
  targetingConditions: fullstory_settings_recording_v1.TargetingConditionSet | null;
  editable: fullstory_settings_recording_v1.Editable;
  exceptionSelectors: string[];
  /** Membership in a privacy rule group. 0 means no group. */
  groupId: number;
}

export interface NamedElementBlockRule {
  id: string;
  name: string;
  description: string;
  platforms: segment.NativePlatform[];
  scope: fullstory_settings_recording_v1.RuleScope;
  targetedSelectors: TargetedSelector[];
  consent: boolean;
  type: fullstory_settings_recording_v1.BlockType;
  editable: fullstory_settings_recording_v1.Editable;
  groupId: number;
  lastUpdated: protobuf.timestamp | null;
  lastUpdatedBy: string;
  createdAt: protobuf.timestamp | null;
}

export interface TargetedSelector {
  selector: string;
  /**
   * Deprecating this platform field in favor of the one in the NamedElementBlockRule.
   * 
   * @deprecated
   */
  platforms: segment.NativePlatform[];
  /** capture client must be at or above this version */
  minVersion: CaptureClientVersion | null;
  /** capture client must be at or below this version */
  maxVersion: CaptureClientVersion | null;
  exceptionSelectors: string[];
  /**
   * Deprecating this scope field in favor of the one in the NamedElementBlockRule.
   * 
   * @deprecated
   */
  scope: fullstory_settings_recording_v1.RuleScope;
}

/** Encoding capture client version for more efficient comparison on the client. */
export interface CaptureClientVersion {
  major: number;
  minor: number;
  patch: number;
}

export interface UpdateNamedElementBlockRuleRequest {
  orgId: string;
  namedElementBlockRule: NamedElementBlockRule | null;
  previousSelector: string;
}

export interface RestoreLegacyElementBlockRulesRequest {
  orgId: string;
}

export interface UpdateNamedElementBlockRuleResponse {
  namedElementBlockRules: NamedElementBlockRule[];
}

export interface GetNamedElementBlockRulesRequest {
  orgId: string;
}

export interface GetNamedElementBlockRulesResponse {
  namedElementBlockRules: NamedElementBlockRule[];
}

export interface DeleteNamedElementBlockRuleRequest {
  orgId: string;
  namedElementBlockRuleId: string;
}

export interface DeleteNamedElementBlockRuleResponse {
  namedElementBlockRules: NamedElementBlockRule[];
}

export interface UpdateFormPrivacyNamedElementBlockRulesRequest {
  orgId: string;
  groupId: number;
  ruleScope: fullstory_settings_recording_v1.RuleScope;
}

export interface BatchUpdateNamedElementBlockRulesRequest {
  orgId: string;
  isMigration: boolean;
  isDryRun: boolean;
}

export interface DatalossIgnoreRule {
  /** Id for this rule */
  id: string;
  /** Type to ignore; must be specified. */
  type: cook.DatalossType;
  /** Source to ignore, or UNKNOWN to allow all sources. */
  source: cook.DatalossSource;
  /** Page URL regex (matches all pages by default). */
  pageUrlRegex: string;
  /** Request URL regex (matches all requests by default). */
  requestUrlRegex: string;
  /** Source-specific "origin" value (string-prefix match; matches all by default). */
  origin: string;
  /** CSS selector to ignore (for element sources; matches all by default). */
  selector: string;
  /** Timestamp for when the DatalossIgnoreRule was last updated */
  lastUpdated: protobuf.timestamp | null;
  /** Note for why the DL event was ignored */
  note: string;
}

export interface ElementBlockRulesUpdate {
  selector: string | null;
  consent: boolean | null;
  notes: string | null;
  type: BlockTypeUpdate | null;
  scope: RuleScopeUpdate | null;
  label: string | null;
  targetingConditions: TargetingConditionSetUpdate | null;
  exceptionSelectors: string[];
  groupId: number | null;
  /** Subset of properties from ElementBlockRules to identify which one to update. */
  key: ElementBlockRuleKey | null;
}

export interface ElementBlockRulesRemove {
  key: ElementBlockRuleKey | null;
}

/**
 * ElementBlockRuleKey represents the subset of ElementBlockRules
 * properties which, in conjunction, identify an element privacy rule.
 * Future properties added to this message should have wrapper types
 * (see ElementBlockRulesUpdate) iff they're optional.
 */
export interface ElementBlockRuleKey {
  selector: string;
  groupId: number;
}

export interface RuleScopeUpdate {
  value: fullstory_settings_recording_v1.RuleScope;
}

export interface ElementPrivacyRuleGroupUpdate {
  /** group_id, template_id are immutable. */
  note: string | null;
  overrides: ElementPrivacyRuleOverrideUpdate | null;
}

export interface ElementPrivacyRuleOverrideUpdate {
  scope: RuleScopeUpdate | null;
}

export interface BlockTypeUpdate {
  value: fullstory_settings_recording_v1.BlockType;
}

export interface DatalossIgnoreRuleUpdate {
  type: DatalossTypeUpdate | null;
  source: DatalossSourceUpdate | null;
  pageUrlRegex: string | null;
  urlRegex: string | null;
  origin: string | null;
  selector: string | null;
  note: string | null;
}

export interface DatalossTypeUpdate {
  value: cook.DatalossType;
}

export interface DatalossSourceUpdate {
  value: cook.DatalossSource;
}

export interface GetPrivacySettingsResponse {
  versions: PrivacySettings[];
}

export interface UpdateDefaultPrivacyModeRequest {
  value: DefaultPrivacyMode;
}

export interface UpdateAutomaticImageUnmaskModeRequest {
  value: AutomaticImageUnmaskMode;
}

export interface UpdatePrivacySettingsRequest {
  orgId: string;
  /** @deprecated */
  addElementBlocks: ElementBlockRules[];
  /** @deprecated */
  updateElementRules: ElementBlockRulesUpdate[];
  /** @deprecated */
  removeElementRules: ElementBlockRulesRemove[];
  addAjaxWatches: fullstory_settings_recording_v1.AjaxWatchRule[];
  removeAjaxWatches: string[];
  updateAjaxWatches: { [key: string]: AjaxWatchRuleUpdate };
  discardIpAddresses: boolean | null;
  defaultPrivacyMode: UpdateDefaultPrivacyModeRequest | null;
  addDatalossIgnores: DatalossIgnoreRule[];
  removeDatalossIgnores: string[];
  updateDatalossIgnores: { [key: string]: DatalossIgnoreRuleUpdate };
  /** @deprecated */
  addElementRuleGroups: fullstory_settings_recording_v1.ElementPrivacyRuleGroup[];
  /** @deprecated */
  removeElementRuleGroups: number[];
  /** @deprecated */
  updateElementRuleGroups: { [key: string]: ElementPrivacyRuleGroupUpdate };
  /**
   * Deprecated in favor of `update_element_rules`, which uses the
   * extensible ElementBlockRuleKey type instead of just the selector
   * `string`.
   * 
   * @deprecated
   */
  updateElementBlocks: { [key: string]: ElementBlockRulesUpdate };
  /**
   * Deprecated in favor of `remove_element_rules`, which uses the
   * extensible ElementBlockRuleKey type instead of just the selector
   * `string`.
   * 
   * @deprecated
   */
  removeElementBlocks: string[];
}

export interface RecordAjaxBodyUpdate {
  value: fullstory_settings_recording_v1.RecordAjaxBody;
}

export interface AjaxWatchRuleUpdate {
  urlRegex: string | null;
  recordReq: RecordAjaxBodyUpdate | null;
  recordRsp: RecordAjaxBodyUpdate | null;
  whitelistReq: string | null;
  whitelistRsp: string | null;
}

export interface UpdateElementBlockRulesRequest {
  orgId: string;
  addElementBlocks: ElementBlockRulesUpdate[];
  updateElementBlocks: ElementBlockRulesUpdate[];
  removeElementBlocks: ElementBlockRuleKey[];
}

export interface UpdateElementBlockRulesResponse {
  elementBlocks: ElementBlockRules[];
}

export interface UpdateDatalossSettingsRequest {
  orgId: string;
  addDatalossIgnores: DatalossIgnoreRule[];
  removeDatalossIgnores: string[];
  updateDatalossIgnores: { [key: string]: DatalossIgnoreRuleUpdate };
}

export interface UpdateDatalossSettingsResponse {
  datalossIgnores: DatalossIgnoreRule[];
}

/** KeepRuleSet is a versioned collection of Keep rules. */
export interface KeepRuleSet {
  rules: KeepRule[];
  metadata: protoauditstore.AuditMetadata | null;
}

/** KeepEventType defines which DOM events will trigger an ELEMENT-type keep rule. */
export enum KeepEventType {
  /** squat on the 0 entry so that the implicit default value has no meaning */
  EVENT_INVALID = 0,
  CLICK = 1
}

/** KeepRuleType defines the types of Keep rules that exist. */
export enum KeepRuleType {
  /** squat on the 0 entry so that the implicit default value has no meaning */
  TYPE_INVALID = 0,
  /** keep the session if the user clicks on the specified element */
  ELEMENT = 1,
  /** keep the session if the user visits the specificed url */
  URL = 2,
  /** keep the session if the user stays on the page for the specified time (or visits >1 page) */
  DWELL = 3
}

export interface KeepRule {
  /** What type of keep rule this is.  Affects semantics of later fields. */
  type: KeepRuleType;
  /** CSS selector for matching elements (if type=ELEMENT) or URL regex (if type=URL) */
  selector: string;
  /** Required page-dwell duration (if type=DWELL), ignored otherwise */
  duration: protobuf.duration | null;
  /** determines whether this rule should only be applied if user has "given" consent via FS('setIdentity', { consent }) */
  consent: boolean;
  /** notes for humans */
  notes: string;
  /** The set of triggering DOM events; applies only if type=ELEMENT */
  events: KeepEventType[];
  /** determines whether the rule is enabled at all */
  enabled: boolean;
  /** populated only in server responses, ignored in server requests */
  lastUpdated: protobuf.timestamp | null;
  lastUpdatedBy: string;
  /** The page types that this rule applies to. If empty, it applies to all types */
  pageTypes: schema.PageType[];
}

export interface GetKeepRulesResponse {
  versions: KeepRuleSet[];
}

export interface UpdateKeepRulesRequest {
  orgId: string;
  /** last_updated and last_updated_by will be ignored */
  ruleAdds: KeepRule[];
  /** rules to delete, by selector only */
  selectorDeletes: string[];
}

export interface UpdateDwellRulesRequest {
  orgId: string;
  duration: protobuf.duration | null;
  remove: boolean;
}

export interface OrgStateTask {
  orgId: string;
  record: OrgStateRecord | null;
}

export interface OrgStateRecord {
  quotaLimit: protobuf.int64;
  flags: flags.FlagsProto | null;
  stage: orgs.PlanStage;
  /** @deprecated */
  integrations: { [key: string]: orgs.Integration };
  lastUpdate: protobuf.timestamp | null;
  period: OrgStateRecord.QuotaPeriod | null;
  metadata: protoauditstore.AuditMetadata | null;
  integrationScripts: string;
  overageLimit: number;
  serverEventsLimit: protobuf.int64;
  /**
   * The percentage of sessions to "drop" from FSTA for orgs utilizing post-cook session sampling.
   * This value is provided as a sampling rate from Webber's Org configuration and transformed to a drop rate.
   */
  splitProcessingDropRate: number;
}

export namespace OrgStateRecord {
  export interface QuotaPeriod {
    quotaCycleStart: protobuf.timestamp | null;
    quotaCycleEnd: protobuf.timestamp | null;
  }
}

export interface GetOrgStatesResponse {
  versions: OrgStateRecord[];
}

export interface CompiledRule {
  expression: string;
  exception: string;
}

/** @deprecated */
export interface Pattern {
  /** @deprecated */
  expression: string;
  goRule: CompiledRule | null;
  jsRule: string;
}

/** @deprecated */
export interface PatternSet {
  hash: Pattern[];
  host: Pattern[];
  path: Pattern[];
  queryParam: Pattern[];
  query: Pattern[];
}

/**
 * A single URL privacy rule.
 * NOTE: (Sean) This will be deprecated once we cut over to the new API.
 * The API definition can be found in fs/api/fullstoryapis/settings/recording/v1alpha/recsettings.proto.
 * 
 * @deprecated
 */
export interface UrlPrivacyRule {
  /** The condition for this rule; if not present, the rule is unconditional. */
  if: PatternSet[];
  /**
   * Exclusions to apply if the condition is true. This too is just a
   * PatternSet; in this context, it's interpreted similarly to the blocklists
   * we have today.
   */
  exclude: PatternSet | null;
}

export interface GetUrlPrivacyRulesResponse {
  urlPrivacyRules: fullstory_settings_recording_v1.UrlPrivacyRule[];
}

export interface GetDetectionsConfigurationRulesResponse {
  detectionsConfigRules: DetectionsConfigurationRules | null;
}

export interface UpdateUrlPrivacyRuleRequest {
  orgId: string;
  urlPrivacyRule: fullstory_settings_recording_v1.UrlPrivacyRule | null;
}

export interface DeleteUrlPrivacyRuleRequest {
  orgId: string;
  guid: string;
}

/** entry for attribute blocklist */
export interface AttributeBlockEntry {
  /** what state of the node does this rule target; valid values are Any, Exclude, Mask */
  target: AttributeBlockTarget;
  /** what tag does this rule target */
  tag: string;
  /** what attribute does this rule target */
  name: string;
  /** what to do with the attribute, valid values are maskText, erase, scrubUrl, scrubCss */
  action: AttributeBlockAction;
  /** optional type of attribute, omitted by default, valid value is "prefix" */
  type: AttributeBlockType;
}

export enum AttributeBlockTarget {
  ANY = 0,
  EXCLUDE = 1,
  MASK = 2
}

/**
 * NOTE: this must be in descending privacy order; that is, the more strict rules must come first
 * When there are overlapping entries, the lowest value action is used
 */
export enum AttributeBlockAction {
  ERASE = 0,
  MASKTEXT = 1,
  SCRUBURL = 2,
  SCRUBCSS = 3
}

export enum AttributeBlockType {
  STATIC = 0,
  PREFIX = 1
}

/**
 * OrgSettings is currently a static and transient data set injected into
 * the recording config. This is a step function for getting all org specific
 * settings out of our recording script (fs.js) and into ingestion settings.
 * todo(clint) - extract into persistent data via recording store
 */
export interface OrgSettings {
  /** Limit number of logs we record */
  maxConsoleLogPerPage: number;
  /**
   * Toggle for recording performance resource timings.
   * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
   */
  recordPerformanceResourceTiming: boolean;
  /** HTTP request headers to allow */
  httpRequestHeadersAllowlist: string[];
  /** HTTP response headers to allow */
  httpResponseHeadersAllowlist: string[];
  /**
   * url query strings regexes to block
   * 
   * @deprecated
   */
  urlQueryStringBlocklist: string[];
  /**
   * url path regexes to block
   * 
   * @deprecated
   */
  urlPathBlocklist: string[];
  /** Toggle for recording performance resource image timings. */
  recordPerformanceResourceImg: boolean;
  /** Limit number of logs we record */
  maxAjaxPayloadLength: number;
  /** @deprecated */
  urlPrivacyConfig: UrlPrivacyRule[];
  /** list of attributes to block */
  attributeBlocklist: AttributeBlockEntry[];
  /** Allow org specific limits to accommodate URLs we ingest */
  maxUrlLength: number;
  /** Limit number of perf mark & measures we record */
  maxPerfMarksPerPage: number;
}

export interface UpdateDefaultPrivacyModeRpcRequest {
  /** The org to update */
  orgId: string;
  /** The new default privacy mode */
  newPrivacyMode: DefaultPrivacyMode;
}

export interface ReconcileOrgJob {
  orgId: string;
}

/**
 * TODO(harris): For now this setting will control whether FS.Focus preview mode is enabled or disabled - whereas
 * the FS.Focus as a whole will continue to be controlled by an org-level feature flag. Long-term we will migrate
 * that feature flag into this enum as a new KEEP_RECORDING_ENABLED option to consolidate things at which point
 * we will have three states: 1. FS.Focus is disabled, 2. FS.Focus is preview mode, 3. FS.Focus is enabled
 */
export enum KeepRecordingType {
  /** placeholder for zero value; not used for anything */
  KEEP_RECORDING_UNSET = 0,
  /** FS.Focus preview mode is disabled */
  KEEP_RECORDING_DISABLED = 1,
  /** FS.Focus preview mode is enabled */
  KEEP_RECORDING_PREVIEW = 2
}

export interface UpdateKeepRecordingType {
  value: KeepRecordingType;
}

export interface ValidateBlockedIpRuleRequest {
  /**
   * Org ID is here only to prevent cross-org requests as a general practice. This particular endpoint does not perform
   * any org-specific logic so we don't really use it for anything in particular.
   */
  orgId: string;
  /** The rule to be validated. */
  blockedIpRule: string[];
}

export interface ValidateBlockedIpRuleResponse {
  /** Maps a problematic blocked IP rule to a user-facing error message (with i18n support) */
  blockedIpRuleErrors: { [key: string]: string };
}

export interface RefreshPublicCaptureConfigRequest {
  orgId: string;
}
